import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';
import routes from 'routes';
import { useGetPracticeSettings } from 'store/settings/selectors';
import { useGetCurrentUser } from 'store/users/selectors';
import GenericLink from 'components/GenericLink/GenericLink';
import LogoIcon from 'components/LogoIcon/LogoIcon';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  @media ${breakpoints.smUp} {
    justify-content: center;
    height: auto;
  }
`;

const LogoWrapper = styled(GenericLink)`
  display: inline-block;
  height: 100%;
  max-width: 100%;

  @media ${breakpoints.smUp} {
    height: ${rem(misc.logoHeight)};
    width: auto;
  }

  img {
    object-fit: contain;
    height: 100%;
    width: auto;
    backface-visibility: hidden;
    transform: translateZ(0);

    @media ${breakpoints.smUp} {
      height: ${rem(misc.logoHeight)};
      max-width: 100%;
    }
  }
`;

const LogoLink = () => {
  const { tradingName } = useGetPracticeSettings();
  const currentUser = useGetCurrentUser();

  return (
    <Wrapper>
      <LogoWrapper
        data-test="logo-link"
        path={currentUser && currentUser.isConfirmed ? routes.root.reactPath() : routes.root.path()}
        title={tradingName}
      >
        <LogoIcon />
      </LogoWrapper>
    </Wrapper>
  );
};

export default LogoLink;
